import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { AuthService } from '../../lib/auth.service';
import { LocalStorages } from '../../lib/util/storages';
import { UIRouter } from '@uirouter/angular';
import { StateName } from '../../app.state-names';
import { ResourceHelper } from '../../lib/util/http-services';
import { EnvironmentFlavour, RuntimeConfiguration } from '../../lib/runtime-configuration';
import { environment } from '../../../environments/environment';
import { LoggerFactory } from '../../util/logger-factory';
import { LoadingHandler } from '../../lib/loading-handler';
import {toasterConfig} from "../../fork/angular2-toaster/src/toaster-config";
import {SidebarNavItemUtils} from "../../shared/sidebar-nav-item/sidebar-nav-item-utils";
import SidebarNavItemModel = SidebarNavItemUtils.SidebarNavItemModel;

@Component({
  selector: 'app-colonnade-online-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class ColonnadeOnlineLayoutComponent implements OnInit {

  toasterConfig = toasterConfig;
  networkLoading: boolean = false;
  private readonly logger = LoggerFactory.createLogger('ColonnadeOnlineLayoutComponent');

  navItems: SidebarNavItemModel[] = [];

  constructor(
    private translateService: TranslateService,
    private authService: AuthService,
    private router: UIRouter,
    private resourceHelper: ResourceHelper
  ) {
    this.updateColonnadeOnlineTranslations();
  }

  ngOnInit(): void {
    const self = this;
    LoadingHandler.getInstance().setOnStartStopListener({
      onStart() {
        self.networkLoading = true;
      },
      onStop() {
        self.networkLoading = false;
      }
    });
  }

  get brandLogoSrc(): string | undefined {
    return this.resourceHelper.getHelpdeskLogoSrc();
  }

  get brandLogoSmallSrc(): string | undefined {
    return this.resourceHelper.getHelpdeskLogoSmallSrc();
  }

  get environmentFlavour(): EnvironmentFlavour {
    return RuntimeConfiguration.getInstance().getEnvironmentFlavour(<EnvironmentFlavour>environment.environmentFlavour);
  }

  private updateColonnadeOnlineTranslations() {
    const lang = this.translateService.currentLang;
    this.translateService.getTranslation(lang).pipe(take(1)).subscribe(() => {
      const context = this;
      const xhr = new XMLHttpRequest();
      xhr.open('GET', '../../../assets/strings/colonnade-online/' + lang + '.json');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function() {
        if (xhr.status === 200) {
          try {
            const data = JSON.parse(xhr.responseText);
            Object.keys(data).forEach(p => {
              context.translateService.set(p, data[p], lang);
            });
          } catch (e) {
            context.logger.error(e);
          }
        } else {
          context.logger.error('Failed loading translations...');
        }
      };
      xhr.onerror = function() {
        context.logger.error('Failed loading translations...');
      };
      xhr.send();
    });
  }

  logout() {
    this.authService.logout({})
      .subscribe(
        () => this.onLogout(),
        () => this.onLogout()
      );
  }

  private onLogout() {
    LocalStorages.onLogout();
    this.router.stateService.go(StateName.COLONNADE_ONLINE_OFFER);
  }
}
